import { List, Map } from 'immutable'
import {
  Component,
  OnInit,
  Input,
  OnChanges,
  ChangeDetectorRef,
  Output,
  EventEmitter,
  OnDestroy,
} from '@angular/core'
import { Subscription } from 'rxjs'
import { getSettingsState } from '@containers/settings/settings.selectors'
import { select, Store } from '@ngrx/store'

@Component({
  selector: 'business-subcategory-slots',
  templateUrl: './business-subcategory-slots.component.html',
  styleUrls: ['./business-subcategory-slots.component.css'],
})
export class BusinessSubcategorySlotsComponent
  implements OnInit, OnChanges, OnDestroy
{
  @Input() public data: List<Map<string, any>>
  @Input() public calculationTypes: any[] = []
  @Input() public errors: any = {}
  @Output() fieldChange: EventEmitter<any> = new EventEmitter()
  @Output() rowDelete: EventEmitter<any> = new EventEmitter()
  @Output() rowAdd: EventEmitter<any> = new EventEmitter()

  public slots = []
  public _errors: any
  public _calculationTypes: any[]

  public calculationTypesTranslateKeys = []
  public calculationTypesTranslateDefaults = {}
  public settings: any = {}
  private settings$: Subscription

  constructor(private cd: ChangeDetectorRef, public store: Store<any>) {}

  ngOnInit(): void {
    this.settings$ = this.store
      .pipe(select(getSettingsState))
      .subscribe((state) => {
        if (state.getIn(['data', 'units'])) {
          this.settings = state.getIn(['data', 'units']).toJS()
        }
      })
  }

  ngOnChanges(): void {
    if (JSON.stringify(this.slots) !== JSON.stringify(this.data)) {
      const _this = this

      this.slots.forEach((slot, i) => {
        if (
          slot.hasRange !== this.data.getIn([i, 'hasRange']) ||
          slot.calculationType !== this.data.getIn([i, 'calculationType'])
        ) {
          _this.cd.reattach()
        }
      })

      this.slots = this.data.toJS()
    }

    if (JSON.stringify(this._errors) !== JSON.stringify(this.errors)) {
      this.cd.reattach()

      this._errors = this.errors
    }

    if (
      JSON.stringify(this.calculationTypes) !==
      JSON.stringify(this._calculationTypes)
    ) {
      this.cd.reattach()
      this._calculationTypes = this.calculationTypes

      this.calculationTypesTranslateKeys = this._calculationTypes.map(
        (type) => type.trnKey,
      )

      this.calculationTypesTranslateDefaults = this._calculationTypes.reduce(
        (prev, current) => {
          return { ...prev, [current.trnKey]: current.defaultName }
        },
        {},
      )
    }
  }

  public getError(i: number, name: string) {
    return this.errors[`${i}.${name}`] ? this.errors[`${i}.${name}`][0] : null
  }

  public handleFieldChange(e: Event, row: number): void {
    this.fieldChange.emit({ e, row })
    this.cd.detach()
  }

  public handleRowDelete(row: number): void {
    this.rowDelete.emit(row)
    this.cd.reattach()
  }

  public handleRowAdd(): void {
    this.rowAdd.emit()
    this.cd.reattach()
  }

  ngOnDestroy(): void {
    if (this.settings$) {
      this.settings$.unsubscribe()
    }
  }
}
